import { AccessReport } from 'presentation/app/modules/Reports/pages/access/access-report';

export const MakeAccessReport = () => {
  return <AccessReport />;
};
